import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// página home
import Home from './pages/home/home';
import Noticia from './pages/comunica/noticias/index.jsx';
import NoticiaDetalhes from './pages/comunica/noticias/noticiasDetalhes.jsx'
import Evento from './pages/comunica/evento/index.jsx';
import EventosDetalhes from './pages/comunica/evento/eventosDetalhes.jsx';

// páginas da seçção Instituição
import Instituicao from './pages/instituicao/index.jsx';
import OrganigramaInstituicao from './pages/instituicao/Organigrama.jsx';
import MissaInstituicaoInstituicao from './pages/instituicao/missao_visao_valores.jsx';
import PalavraPresidenteInstituicao from './pages/instituicao/palavra-do-presidente.jsx';
import PerguntasFrequentesInstituicao from './pages/instituicao/perguntas-frequentes.jsx';
import AccaoSocial from './pages/instituicao/apoio-social.jsx';
import Legalidade from './pages/instituicao/legalidade.jsx';

// páginas da seçção Programas

import UnidadeOrganica from './pages/programas/unidade_organica/index.jsx';
import Licenciatuara from './pages/programas/licenciatura.jsx';
// Importando as páginas da seção de Ciência e Saúde
import DocentesCS from './pages/programas/unidade_organica/ciencia_saude/docentes.jsx';
import MissaoCS from './pages/programas/unidade_organica/ciencia_saude/missao-visao-valores.jsx';
import CienciaSaude from './pages/programas/unidade_organica/ciencia_saude/index.jsx';

//Páginas da seção de internacional
import PorqueISpa from './pages/internacional/porque-ispa.jsx'
import EstudanteInternacional from './pages/internacional/estudante-internacional.jsx'
import CursosInt from './pages/internacional/licenciatura.jsx'
import Alojamento from './pages/internacional/alojamento.jsx' 

//Páginas da sesão de recursos 
import Jornada from './pages/investigacao/index.jsx'
import Taxa from './pages/investigacao/Taxa.jsx'
import BibliotecaVirtual from './pages/investigacao/bibliotecaVirtual.jsx';

// Páginas da comunicação
import Eventos from './pages/comunica/evento/index.jsx';
import Noticias from './pages/comunica/noticias/index.jsx';

//PAGINAS DO PORTAL DO ESTUDANTES

import Preparatorio from './pages/estudantes/p_online/index.jsx'
import Candidatura from './pages/estudantes/p_online/PublicApplicationForm.js'
import PainelAdmin from './pages/estudantes/p_online/AdminPanel.js'


function App() {
  return (
        <>
        <BrowserRouter>
          <Routes>
            {/* Rotas principais */}
            <Route path="/" element={<Home />} />
            <Route path="/noticia" element={<Noticia />} />
            <Route path="/noticia/:id" element={<NoticiaDetalhes />} />
            <Route path="/evento" element={<Evento />} />
            <Route path="/evento/:id" element={<EventosDetalhes />} />
            <Route path="/instituicao" element={<Instituicao />} />
            <Route path="/instituicao/organigrama" element={<OrganigramaInstituicao />} />
            <Route path="/instituicao/missao-visao-valores" element={<MissaInstituicaoInstituicao />} />
            <Route path="/instituicao/palavra-do-presidente" element={<PalavraPresidenteInstituicao />} />
            <Route path="/instituicao/perguntas-frequentes" element={<PerguntasFrequentesInstituicao />} />
            <Route path="/instituicao/apoio-social" element={<AccaoSocial />} />
            <Route path="/instituicao/legalidade" element={<Legalidade />} />

            {/* Páginas da seção de programas */}
            <Route path="/programas/licenciatura" element={<Licenciatuara />} />
            <Route path="/programas/unidade-organica" element={<UnidadeOrganica />} />
            <Route path="/programas/unidade-organica/ciencia-saude" element={<CienciaSaude />} />
            <Route path="/programas/unidade-organica/ciencia-saude/docentes" element={<DocentesCS />} />
            <Route path="/programas/unidade-organica/ciencia-saude/missao-visao-valores" element={<MissaoCS />} />

            {/* Páginas da seção de internacional */}
            <Route path="/internacional/porque-ispa" element={<PorqueISpa />} />
            <Route path="/internacional/estudante" element={<EstudanteInternacional />} />
            <Route path="/internacional/licenciatura" element={<CursosInt />} />
            <Route path="/internacional/alojamento" element={<Alojamento />} />
            
            {/* Páginas da seção de recursos */}
            <Route path="/investigacao/jornada" element={<Jornada />} />
            <Route path="/investigacao/taxa" element={<Taxa />} />
            <Route path="/investigacao/Biblioteca-virtual" element={<BibliotecaVirtual />} /> 

          { /* Páginas da seção de comunicação */}
            <Route path="/comunicacao/eventos" element={<Eventos />} />
            <Route path="/comunicacao/noticias" element={<Noticias />} />

          { /* Páginas da seção de do portal de estudante */}
          <Route path='/portal-do-estudante/preparatorio-online' element={<Preparatorio />} />
          <Route path='/portal-do-estudante/Candidatura-online' element={<Candidatura />} />
          <Route path='/portal-do-estudante/admin-Candidatura' element={<PainelAdmin />} />

          </Routes>
        </BrowserRouter>
        </>
  );
}

export default App;
